import { type PlacementDetails as AccommodationDetail } from 'src/store/placementDetailsPageSlice/types';

import rtwClient from '../apiService';

class JmrService {
  /**
   * Get accommodation detail
   */
  public async getAccommodationDetail(accommodationId: number) {
    return await rtwClient.get<AccommodationDetail>(`/accommodation/detail/${accommodationId}`);
  }

  /**
   * Get accommodation detail base on austin case and user login
   */
  public async getAccommodationIdByCaseIdAndLogin(type: string, caseId: string, login: string) {
    const res = await rtwClient.get<number>(`/accommodation/type/${type}/caseId/${caseId}/login/${login}`);
    return res;
  }

  /**
   * Delete accommodation
   */
  public async deleteAccommodation(accommodationId: number) {
    return await rtwClient.delete(`/accommodation/${accommodationId}`);
  }
}

export default new JmrService();
